import { v4 as uuid } from "uuid";

export default function useManufacturerHeader() {
  const headers = [
    {
      id: uuid(),
      title: "STT",
      width: "20px",
      align: "center",
    },
    {
      id: uuid(),
      title: "Tên",
      width: "160px",
      align: "center",
    },
    {
      id: uuid(),
      title: "Xuất xứ",
      width: "260px",
      align: "center",
    },
    {
      id: uuid(),
      title: "Thao tác",
      width: "100px",
      align: "center",
    },
  ];
  return headers;
}
